import { ReactComponent as PlusRoundedSvg } from '../../assets/icons/plus-rounded.svg';

export const PlusRoundedIcon: SvgIcon = (props) => {
    return <PlusRoundedSvg {...props} />;
};
